import { Translations } from './en';

const fr: Translations = {
  global: 'Global',
  variation: 'Variation',
  distribution: 'Distribution',
  decomposition: 'Décomposition',
  tracking: 'Suivi',
};

export default fr;
